var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
/* Below this alpha a pixel's colour is unreliable (the browser stores canvas
 * pixels premultiplied, so a faint pixel's colour comes back coarse) and is
 * replaced too. */
var SOLID_ALPHA = 64;
/**
 * Gives every transparent (and faint) pixel of straight-alpha RGBA data the
 * colour of its nearest solid pixel, leaving alpha alone. A browser decodes
 * transparent pixels as black, and texture filtering averages colours without
 * weighting them by alpha, so an icon drawn smaller than its texture gets a
 * dark, uneven rim; with the edge colour bled outwards it keeps its own.
 */
export var bleedIntoTransparentPixels = function (data, width, height) {
    var e_1, _a;
    var pixelCount = width * height;
    var done = new Uint8Array(pixelCount);
    var queue = new Int32Array(pixelCount);
    var tail = 0;
    for (var i = 0; i < pixelCount; i++) {
        if (data[i * 4 + 3] >= SOLID_ALPHA) {
            done[i] = 1;
            queue[tail++] = i;
        }
    }
    /* Breadth first from all solid pixels at once, so each pixel takes the
     * colour of the (roughly) nearest one. */
    for (var head = 0; head < tail; head++) {
        var from = queue[head];
        var x = from % width;
        var neighbours = [
            x > 0 ? from - 1 : -1,
            x < width - 1 ? from + 1 : -1,
            from - width,
            from + width,
        ];
        try {
            for (var neighbours_1 = (e_1 = void 0, __values(neighbours)), neighbours_1_1 = neighbours_1.next(); !neighbours_1_1.done; neighbours_1_1 = neighbours_1.next()) {
                var to = neighbours_1_1.value;
                if (to < 0 || to >= pixelCount || done[to])
                    continue;
                done[to] = 1;
                data[to * 4] = data[from * 4];
                data[to * 4 + 1] = data[from * 4 + 1];
                data[to * 4 + 2] = data[from * 4 + 2];
                queue[tail++] = to;
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (neighbours_1_1 && !neighbours_1_1.done && (_a = neighbours_1.return)) _a.call(neighbours_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
    }
};
